<template>
  <div class="w-100 p-2 mt-2">
    <page-header>
      <i class="fas fa-list"></i> {{ $t('scheduled_tournament_calendar.page.title') }}
    </page-header>
    <CreateModal ref="create-schedule-tournament-modal"></CreateModal>
    <page-card>
      <template v-slot:header>
        {{ $t('title.filters') }}
      </template>
      <template v-slot:content>
        <div class="row d-flex justify-content-center">
          <div class="col-10 ">
            <calendar
                :first-day="1"
                :all-events="scheduledTournaments"
            ></calendar>
          </div>
        </div>
      </template>
    </page-card>
  </div>
</template>

<script>
import Calendar from "../../../components/BootstrapCalendar/Calendar";
import {mapState} from "vuex";
import {DAY_SELECTED} from "../../../components/BootstrapCalendar/actions";
import PageHeader from "../../../components/page/PageHeader";
import PageCard from "../../../components/page/PageCard";
import CreateModal from "./CreateModal";

export default {
  data() {
    return {
      createModalInstance: null,
      isModalOpened: false
    }
  },
  components: {
    CreateModal,
    Calendar,
    PageHeader,
    PageCard
  },
  computed: mapState({
    scheduledTournaments: state => state.scheduledTournament.scheduledTournaments,
  }),
  methods: {
    openModal(date) {
      this.$refs['create-schedule-tournament-modal'].openModal(date);
    }
  },
  mounted() {
    this.$root.$on(DAY_SELECTED,  (e) => {
      this.openModal(e.dayDate);
    });


    this.$store.dispatch('scheduledTournament/getScheduledTournaments');
  }
}
</script>